import { useSearchStore } from '../stores/SearchStore';

export function useSearch() {
  const search = useSearchStore((state) => state.search);
  const setSearch = useSearchStore((state) => state.setSearch);

  return { search, setSearch };
}
